(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[733],{

/***/ 7522:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate",
      function () {
        return __webpack_require__(3417);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9521);
/* harmony import */ var lib_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9434);
/* harmony import */ var lib_utils_configs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2670);
/* harmony import */ var lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5537);
/* harmony import */ var context_state_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2807);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1387);
/* harmony import */ var components_RegCodeInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9584);
/* harmony import */ var components_ErrorBanner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3308);
/* harmony import */ var components_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2513);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1407);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 180px;\n  padding: 0;\n  margin: 0 auto 2rem;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: -0.5px;\n  line-height: 1.3em;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var IndexPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), regCodeError = ref[0], setRegCodeError = ref[1];
    var dispatch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_8__/* .AppContext */ .I).dispatch;
    var profile = (0,lib_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGetProfileSdk */ .Iw)(lib_utils_configs__WEBPACK_IMPORTED_MODULE_5__/* .profileConfig */ .Vc);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_7__/* .setError */ .sT)(""));
        dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_7__/* .setFlowStage */ .Kc)(constants_index__WEBPACK_IMPORTED_MODULE_12__/* .FLOW_STAGE_ENTER_REG_CODE */ .h3));
        router.prefetch(constants_index__WEBPACK_IMPORTED_MODULE_12__/* .ROUTE_MVPD */ .W3);
        router.prefetch(constants_index__WEBPACK_IMPORTED_MODULE_12__/* .ROUTE_ACCOUNT */ .I);
    }, [
        dispatch,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__/* .mountDataLayer */ .jV)();
        (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__/* .setPageAnalyticsData */ .l9)({
            pageName: lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__/* .PageNames.SUBMIT_CODE_LANDING */ .sn.SUBMIT_CODE_LANDING,
            pageType: lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__/* .PageTypes.ACTIVATION_CODE */ .c7.ACTIVATION_CODE
        });
        (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__/* .handleHomePageEvent */ .qH)();
        return function() {
            return (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_6__/* .setPageAnalyticsData */ .l9)({
                pageName: "",
                pageType: ""
            });
        };
    }, []);
    if (!profile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_11__/* .Loader */ .aN, {
        abCenter: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_11__/* .SEO */ .HJ, {
                title: "Home"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Home, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(H2, {
                        children: [
                            "Enter the code ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "displayed on your TV screen."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_RegCodeInput__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        profile: profile,
                        setRegCodeError: setRegCodeError
                    })
                ]
            }),
            regCodeError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_ErrorBanner__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_11__/* .Footer */ .$_, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);
var Home = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-46ce7181-0"
})(_templateObject());
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-46ce7181-1"
})(_templateObject1());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [130,721,513,572,774,888,179], function() { return __webpack_exec__(7522); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);